import angular from 'angular';

import template from './patientConnection.verifyForm.html';
import './patientConnection.verifyForm.less';

class VerifyFormController {
    constructor(AppUserService) {
        'ngInject';
        this.AppUserService = AppUserService;
        this.isNewUser = this.AppUserService.isNewUser();
    }

    $onInit() {
        this.datepickerOptions = {
            formatDay: 'd',
            showWeeks: false,
            // maxDate: moment().format('mm/dd/YYYY'),
            datepickerMode: 'year'
        };
        this.formFields = {};
        this.isDobPickerOpen = false;
        this.currentForm = this.currentForm || 'verifyForm';
    }

    $onChanges(changes) {
        if (changes.connectionModel) {
            this.connectionModel = angular.copy(this.connectionModel);

            let {connectionUser, verifyFields} = this.connectionModel;
            if (this.isNewUser) {
                this.currentForm = 'confirmForm';
                this.confirmUser = {
                    type: connectionUser.type,
                    firstName: connectionUser.firstName || '',
                    middleInitial: connectionUser.middleInitial || '',
                    lastName: connectionUser.lastName || '',
                    relationship: connectionUser.relationship || ''
                };
            } else {
                delete this.confirmUser;
            }

            verifyFields = verifyFields || [];
            this.showDob =  verifyFields.indexOf('dob') > -1;
            this.showZipCode =  verifyFields.indexOf('zipcode') > -1;
        }
        if (changes.patient) {
            this.patient = angular.copy(this.patient);
        }
        if (changes.careTeam) {
            this.careTeam = angular.copy(this.careTeam);
        }

        this.verifyError = this.verifyError || '';
    }

    openDobPicker() {
        this.isDobPickerOpen = true;
    }

    handleConfirm() {
        this.currentForm = 'verifyForm';
    }

    handleVerify(formFields) {
        let data = {verifyFields: formFields};
        if (this.confirmUser) {
            data.confirmUser = this.confirmUser;
        }
        this.onVerify({
            $event: data
        });
    }

}

export const VerifyFormComponent = {
    name: 'mmsPatientConnectionVerifyForm',
    component: {
        template: template,
        controller: VerifyFormController,
        bindings: {
            patient: '<',
            careTeam: '<',
            connectionModel: '<',
            verifyError: '<',
            onVerify: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/verifyForm/patientConnection.verifyForm.component.js